var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "220.3,204 220.3,224.3 220.3,291.1 300.7,247.7 256.7,223.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251,3.3C114.2,3.3,3.3,114.2,3.3,251c0,136.8,110.9,247.7,247.7,247.7c136.8,0,247.7-110.9,247.7-247.7 C498.7,114.2,387.8,3.3,251,3.3z M399.7,243.5v19.2c0,25.2-2.9,50-2.9,50s-3.1,21.4-11.9,31c-11.3,12.4-24,12.4-29.7,13.2 c-41.6,2.9-104,3.2-104,3.2s-77.4-0.8-101.1-3.2c-6.8-1.3-21.6-0.8-32.9-13.2c-8.9-9.5-11.9-31-11.9-31s-3.1-24.8-3.1-50v-20.5V239 c0-24.8,3.1-50,3.1-50s3.1-21.4,11.9-30.8c11.3-12.3,23.9-12.4,29.8-13.2c41.6-3.1,103.8-3.1,103.8-3.1h0.3c0,0,62.4,0,104,3.1 c5.6,0.8,18.4,1,29.7,13.2c8.9,9.4,11.9,30.8,11.9,30.8s2.9,25.2,2.9,50V243.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social_youtube.17ddcff0eb8515a367a32bde68487969.svg";
export { ForwardRef as ReactComponent };